export default __webpack_public_path__ + "static/media/slide02.96535dcf.jpg";